import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";
import { Messages } from "../../core/api";
import { PayrollBatchId } from "../../shared/schema/schema";

export default createQueryGroup(({ api }) => {
  return {
    payrollVerification: (id: PayrollBatchId, count?: number) =>
      queryOptions({
        queryKey: ["payroll-verification", id],
        queryFn: () => {
          return api.get("./payroll_verification/:payrollBatchId", {
            path: { payrollBatchId: id },
            query: { count },
          });
        },
      }),
    payrollAudit: (id: PayrollBatchId, serviceTypes: Messages["PayrollAuditServiceType"][]) =>
      queryOptions({
        queryKey: ["payroll-audit", id, serviceTypes],
        queryFn: () => {
          return api.get("./payroll_audit/:payrollBatchId", {
            path: { payrollBatchId: id },
            query: { serviceTypes },
          });
        },
      }),
  };
});
